export const PRIMARY_EMOJIS = ['👍', '👏', '🎉', '❤️', '😄', '😥', '😱'];
